(function () {
	'use strict';

		angular.module('qbePortal').directive('qbEmptyShedValidation', [function () {
			return {
				restrict:'AE',
				scope: {
					shedModels:'<',
					ngModel:'<',
					trigger:'<'
				},
				hasValidSheds:function(shedModels){
					var zeroItems=0;
					if(Array.isArray(shedModels)){
						shedModels.forEach(function(item){
							if(item!=undefined && item!=null && item===0){
								zeroItems++;
							}
						});
					}
					return zeroItems!=shedModels.length;
				},
				link: function (scope, element, attrs){
					scope.checkValidSheds = this.hasValidSheds;

					scope.$watch('shedModels',function(newValue,oldValue,scope){
						if (scope.ngModel!=undefined) {
							if(scope.trigger){
					 			scope.ngModel.$setValidity('qbEmptyShedValidation', scope.checkValidSheds(newValue));
						 	}
						 	else{
						 		scope.ngModel.$setValidity('qbEmptyShedValidation', false);
						 	}
						}
						
					});

					scope.$watch('trigger',function(newValue,oldValue,scope){
						
						if (scope.ngModel!=undefined) {
							if(newValue!=undefined && newValue===false ){
							scope.ngModel.$setValidity('qbEmptyShedValidation', true);
							}
							else{
								scope.ngModel.$setValidity('qbEmptyShedValidation', scope.checkValidSheds(scope.shedModels));
							}
						}						
					});
				},

			}
		}]);
	})();
